import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const PercentageCircleWrapper = styled.div<{ percentageValue: number }>`
  margin-right: 1rem;
  min-width: 4rem;
  min-height: 4rem;
  width: 4rem;
  height: 4rem;
  max-width: 4rem;
  max-height: 4rem;
  background: #f4f4f4;
  border-radius: 50%;
  overflow: hidden;
  position: relative;

  @keyframes fill {
    0% {
      transform: rotate(0deg);
    }
    100% {
      ${({ percentageValue }) => `transform: rotate(${180 * (percentageValue / 100)}deg);`}
    }
  }

  .circle {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .inside-circle {
    width: 3.5rem;
    height: 3.5rem;
    margin-top: 0.25rem;
    margin-left: 0.25rem;
    border-radius: 50%;
    background: #fff;
    line-height: 3.5rem;
    text-align: center;
    position: absolute;
    z-index: 100;
    font-weight: 700;
    font-size: 0.8125rem;
    top: 0;
    padding-left: 0.25rem;
  }
  .circle .mask,
  .circle .fill {
    width: 4rem;
    height: 4rem;
    position: absolute;
    border-radius: 50%;
    top: 0;
  }
  .circle .mask.full,
  .circle .fill {
    animation: fill ease-in-out 0.75s;
    ${({ percentageValue }) => `transform: rotate(${180 * (percentageValue / 100)}deg);`}
  }
  .circle .mask {
    clip: rect(0, 4rem, 4rem, 2rem);
  }
  .circle .mask .fill {
    clip: rect(0px, 2rem, 4rem, 0px);
    background-color: ${({ theme }) => theme.primary.color.normal};
  }
`;

interface PercentageCircleProps {
  summaryValues: {
    recommended: number;
    reviews: number;
  };
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const PercentageCircle: FunctionComponent<PercentageCircleProps> = ({ summaryValues }) => (
  <PercentageCircleWrapper
    percentageValue={(summaryValues?.recommended / summaryValues?.reviews) * 100}
  >
    <div className="circle">
      <div className="mask full">
        <div className="fill" />
      </div>
      <div className="mask half">
        <div className="fill" />
      </div>
      <div className="inside-circle">
        {Math.floor((summaryValues?.recommended / summaryValues?.reviews) * 100)}%
      </div>
    </div>
  </PercentageCircleWrapper>
);

export default PercentageCircle;
